<template>
  <div class="session-public-overlay">
    <Modal
      id="modal_session_public_warning"
      variant="warning"
      hide-close-btn
    >
      <template #title>
        {{ $t("session_public.titre") }}
      </template>
      <template #content>
        <p class="text-regular message">
          {{ $t("session_public.message") }}
        </p>
      </template>
      <template #footer>
        <ButtonClassic
          variant="solid"
          color="primary"
          :label="$t('session_public.acceder_espace_connecte')"
          @click="goToConnectedSpace()"
        />
        <ButtonClassic
          variant="solid"
          color="secondary"
          :label="$t('session_public.se_deconnecter')"
          @click="logout()"
        />
      </template>
    </Modal>
  </div>
</template>

<script>
import { ButtonClassic, Modal } from "@lde/core_lde_vue";

import config from "@/config";
import { getConnectedUrl } from "@/modules/utils";

/**
 * Modale bloquante affichée lorsqu'un utilisateur connecté se trouve sur le domaine du catalogue public.
 * Elle invite l'utilisateur à se déconnecter ou à rejoindre son espace connecté.
 */
export default {
  name: "ModalSessionPublicWarning",
  components: {
    Modal,
    ButtonClassic,
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$modal) {
        this.$modal.show("modal_session_public_warning");
      }
    });
  },
  methods: {
    goToConnectedSpace() {
      this.$store.commit("setIsRedirecting", true);
      window.location.href = getConnectedUrl();
    },
    logout() {
      this.$store.commit("setIsRedirecting", true);
      window.location.href = config.logoutUrl;
    },
  },
};
</script>

<style lang="scss">
@use "~@lde/core_lde_vue/dist/assets/styles/_variables.scss" as var;

.session-public-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.85);
}

#modal_session_public_warning {
  .message {
    margin-top: var.$space-small;
    margin-bottom: var.$space-medium;
  }
}
</style>

